
export const REQUEST_LOAD_PERSONAL_WORKOUTS = 'events/REQUEST_LOAD_PERSONAL_WORKOUTS';
export const REQUEST_LOAD_PERSONAL_WORKOUT_EVENTS = 'events/REQUEST_LOAD_PERSONAL_WORKOUT_EVENTS';
